module.exports = __webpack_public_path__ + "img/carshina22_23.591a5823.jpg";